import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hp_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("hp_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    const pid = product._id || product.slug;
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === pid);
      if (found) {
        return prev.map((i) =>
          i.product_id === pid ? { ...i, quantity: i.quantity + qty } : i
        );
      }
      return [
        ...prev,
        {
          product_id: pid,
          slug: product.slug,
          name: product.name,
          price: product.price,
          image: product.image,
          quantity: qty,
        },
      ];
    });
    setOpen(true);
  };

  const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));

  const setQty = (pid, qty) =>
    setItems((prev) =>
      prev
        .map((i) => (i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i))
        .filter((i) => i.quantity > 0)
    );

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, add, remove, setQty, clear, count, total, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
